module.exports = "/_next/static/images/5ece2e2755896ad1b6a793d7be9fa8b8-savings-without-logos-lg-2x.jpg";